import PropTypes from 'prop-types';
import { FrameWithStickyTitle } from 'components/BrandSlides/BrandSlides';
import { ensureArray, safeMap, safeGetProp, ensureString } from 'utils/safeArray';

/**
 * VideoMockup slide component for displaying video panels
 */
export default function VideoMockup({ title, panels, accent_color }) {
  const safePanels = ensureArray(panels);
  
  return (
    <FrameWithStickyTitle title={title} accentColor={accent_color}>
      <div className="flex flex-col pt-2">
        {safeMap(safePanels, (panel, idx) => {
          const panelTitle = ensureString(safeGetProp(panel, 'title'), `Video ${idx + 1}`);
          const videoUrl = ensureString(safeGetProp(panel, 'video_url') || safeGetProp(panel, 'videoUrl'), '');
          const description = ensureString(safeGetProp(panel, 'description'), '');
          
          return (
            <div key={idx} className="flex flex-col">
              <div className="flex items-center justify-between mb-2">
                <h3 className="text-lg font-semibold text-slate-800 uppercase tracking-wide">{panelTitle}</h3>
                {description && (
                  <span className="text-base text-slate-600 font-medium ml-4">{description}</span>
                )}
              </div>
              <div className="border-2 rounded-lg p-3 bg-white shadow-sm" style={{ borderColor: accent_color || '#cc0000' }}>
                {videoUrl ? (
                  <video 
                    controls 
                    className="w-full rounded-md" 
                    src={videoUrl}
                    style={{ maxHeight: '40vh', objectFit: 'contain' }}
                  >
                    <track kind="captions" />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <div className="w-full bg-slate-100 rounded-md flex items-center justify-center" style={{ height: '60vh' }}>
                    <div className="text-center p-4">
                      <div className="text-4xl mb-2">🎬</div>
                      <div className="text-sm text-slate-600 font-medium">{panelTitle}</div>
                      <div className="text-xs text-slate-500 mt-1">No video URL provided</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
        
        {/* Experimental Feature Notice */}
        <div className="mt-2 pt-2 border-t border-slate-200 w-full">
          <p className="text-xs text-slate-400 text-center italic">
            Note: This feature is experimental. Latest video generation models may not be optimal for generating text content.
          </p>
        </div>
      </div>
    </FrameWithStickyTitle>
  );
}

VideoMockup.propTypes = {
  title: PropTypes.string,
  panels: PropTypes.array,
  accent_color: PropTypes.string,
};

